import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/layout/Navigation';
import LoadingSkeleton from './components/common/LoadingSkeleton';
import MockDataBanner from './components/MockDataBanner';

// Lazy load route components for code-splitting
const Home = lazy(() => import('./routes/Home'));
const Champions = lazy(() => import('./routes/Champions'));
const ChampionDetail = lazy(() => import('./routes/ChampionDetail'));
const PatchComparison = lazy(() => import('./routes/PatchComparison'));
const RoleMeta = lazy(() => import('./routes/RoleMeta'));
const HiddenGems = lazy(() => import('./routes/HiddenGems'));
const Operations = lazy(() => import('./routes/Operations'));

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="min-h-screen bg-rift-navy text-white">
        <MockDataBanner />
        <Navigation />
        <Suspense fallback={
          <div className="p-6">
            <LoadingSkeleton type="card" count={5} />
          </div>
        }>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/champions" element={<Champions />} />
            <Route path="/champions/:id" element={<ChampionDetail />} />
            <Route path="/patches/compare" element={<PatchComparison />} />
            <Route path="/roles/:role" element={<RoleMeta />} />
            <Route path="/hidden-gems" element={<HiddenGems />} />
            <Route path="/operations" element={<Operations />} />
          </Routes>
        </Suspense>
      </div>
    </BrowserRouter>
  );
}

export default App;
